module.exports = __webpack_public_path__ + "assets/img/8.527b8f8b.png";